export default class BatchActionDefinition
{
    constructor(name, label, action, enabled = true) {
        this.name = name;
        this.action = action;
        this.label = label;
        this.enabled = enabled;
        this.metas = {};
    }

    build() {
        return {
            name: "updatePrefsThird",
            label: typeof this.label == 'function' ? this.label() : this.label,
            action: typeof this.action == 'function' ? this.action() : this.action,
            enabled: typeof this.enabled == 'function' ? this.enabled() : this.enabled,
        };
    }
}